<template>
    <div class="my-view-comment-item">
        <div class="my-view-comment-author">
            <a class="">
                <!--评论的用户头像-->
                <img class="my-view-picture" :src="comment.author.avatar"></img>
            </a>
            <div class="my-view-info">
                <!--用户名-->
                <span class="my-view-nickname">{{comment.author.nickname}}</span>
                <div class="my-view-meta">
                    <!--评论的第几楼-->
                    <span>{{rootCommentCounts - index}}楼</span>&nbsp;
                    <span>{{comment.createDate | format}}</span>
                </div>
            </div>
        </div>
        <div>
            <!--评论的内容-->
            <p class="my-view-comment-content">{{comment.content}}</p>
            <div class="my-view-comment-tools">
                <!--<a class="my-view-comment-tool">-->
                <!--<i class="el-icon-caret-top"></i> 20-->
                <!--</a>-->
                <!--其他用户也可以评论该评论-->
                <a class="my-view-comment-tool" @click="showComment(-1,comment.author)">
                    <i class="el-icon-caret-top"></i>&nbsp;评论
                </a>
            </div>

            <!--评论的评论-->
            <div class="my-reply-list">
                <div class="my-reply-item" v-for="c in comment.children" :key="c.id">
                    <div style="font-size: 14px">
                        <!--评论人名称-->
                        <span class="my-reply-user">{{c.author.nickname}}:&nbsp;&nbsp;</span>
                        <!--被评论人名称-->
                        <span v-if="c.level == 2" class="my-reply-user">@{{c.toUser.nickname}} </span>

                        <span>{{c.content}}</span>
                    </div>
                    <div class="my-view-meta">
                        <span style="padding-right: 10px">{{c.createDate | format}}</span>
                        <!--  <a class="my-view-comment-tool" @click="showComment(c.id, c.author)">
                            <i class="my-icon-comment"></i>&nbsp;回复
                          </a> -->
                    </div>
                </div>

                <!--评论其他用户的评论-->
                <div class="my-view-comment-write" v-show="commentShow">
                    <el-input
                            v-model="reply.content"
                            type="input"
                            style="width: 90%"
                            :placeholder="placeholder"
                            class="my-view-comment-text"
                            resize="none"
                            ref="customerInput"
                    >
                    </el-input>

                    <el-button style="margin-left: 8px" @click="publishComment()" type="text">评论</el-button>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
    import {publishComment} from '@/api/comment'

    export default {
        name: "CommentItem",
        props: {
            articleId: String,
            comment: Object,
            index: Number,
            rootCommentCounts: Number
        },
        data() {
            return {
                placeholder: '你的评论...',
                commentShow: false,
                commentShowIndex: '',
                reply: this.getEmptyReply()
            }
        },
        methods: {
            showComment(commentShowIndex, toUser) {
                this.reply = this.getEmptyReply();
                /*如果评论索引不为-1*/
                if (this.commentShowIndex !== commentShowIndex) {
                    if (toUser) {
                        this.placeholder = `@${toUser.nickname} `
                        this.reply.toUserId = toUser.id
                    } else {
                        this.placeholder = '你的评论...'
                    }
                    this.commentShow = true;
                    this.commentShowIndex = commentShowIndex;
                    /*input框聚焦*/
                    this.$nextTick(function () {
                        this.$refs.customerInput.$el.querySelector('input').focus();
                    });
                } else {
                    this.commentShow = false;
                    this.commentShowIndex = '';
                }
            },
            publishComment() {
                let that = this;
                if (!that.reply.content) {
                    return;
                }
                publishComment(that.reply, this.$store.state.token).then(res => {
                    if (res.data.success) {
                        console.log(1)
                        that.$message({type: 'success', message: '评论成功', showClose: true})
                        if (!that.comment.childrens) {
                            that.comment.childrens = []
                        }
                        that.comment.children.unshift(res.data.data);

                        that.$emit('commentCountsIncrement');
                        /*刷新当前组件*/
                        that.showComment(that.commentShowIndex);
                        that.$emit('findCommentListByArticleId');
                    } else {
                        that.$message({type: 'error', message: res.data.msg, showClose: true})
                    }
                }).catch(error => {
                    if (error !== 'error') {
                        that.$message({type: 'error', message: '评论失败', showClose: true})
                    }
                })

            },
            getEmptyReply() {
                return {
                    articleId: this.articleId,
                    parentId: this.comment.id,
                    toUserId: '',
                    content: ''
                }
            }
        }
    }
</script>

<style>

    .my-view-tag-item {
        margin: 0 4px;
    }

    .my-view-comment {
        margin-top: 60px;
    }

    .my-view-comment-title {
        font-weight: 600;
        border-bottom: 1px solid #f0f0f0;
        padding-bottom: 20px;
    }

    .my-view-comment-write {
        margin-top: 20px;
    }

    .my-view-comment-text {
        font-size: 16px;
    }

    .v-show-content {
        padding: 8px 25px 15px 30px !important;
    }

    .v-note-wrapper .v-note-panel {
        box-shadow: none !important;
    }

    .my-view-comment-item {
        margin-top: 20px;
        padding-bottom: 16px;
        border-bottom: 1px solid #f0f0f0;
    }

    .my-view-comment-author {
        margin: 10px 0;
        vertical-align: middle;
        display: flex;
        align-items: center;
        gap: 10px;
    }

    /* 评论头像固定小尺寸，避免大图撑满 */
    .my-view-comment-author .my-view-picture {
        width: 36px;
        height: 36px;
        min-width: 36px;
        min-height: 36px;
        max-width: 36px;
        max-height: 36px;
        object-fit: cover;
        border-radius: 50%;
        flex-shrink: 0;
    }

    .my-view-nickname {
        font-size: 14px;
    }

    .my-view-comment-content {
        line-height: 1.5;
    }

    .my-view-comment-tools {
        margin-top: 4px;
        margin-bottom: 10px;
    }

    .my-view-comment-tool {
        font-size: 13px;
        color: #a6a6a6;
        padding-right: 14px;
    }

    .v-note-wrapper .v-note-panel .v-note-show .v-show-content, .v-note-wrapper .v-note-panel .v-note-show .v-show-content-html {
        background: #fff !important;
    }

    .my-reply-list {
        padding-left: 16px;
        border-left: 4px solid #c5cac3;
    }

    .my-reply-item {
        margin-bottom: 8px;
        border-bottom: 1px solid #f0f0f0;
    }

    .my-reply-user {
        color: #78b6f7;
    }
</style>

<style>
    /* 文章详情页评论区：科技风下评论与操作清晰可见 */
    .article-detail-page .my-view-comment-item {
        border-bottom-color: rgba(0, 255, 245, 0.15);
        padding-bottom: 20px;
    }

    .article-detail-page .my-view-comment-author .my-view-picture {
        width: 36px !important;
        height: 36px !important;
        min-width: 36px !important;
        min-height: 36px !important;
        max-width: 36px !important;
        max-height: 36px !important;
        object-fit: cover;
        border: 1px solid rgba(0, 255, 245, 0.3);
        box-shadow: 0 0 10px rgba(0, 255, 245, 0.15);
    }

    .article-detail-page .my-view-nickname {
        color: rgba(224, 242, 254, 0.95);
    }

    .article-detail-page .my-view-comment-item .my-view-meta {
        color: rgba(148, 163, 184, 0.9);
    }

    .article-detail-page .my-view-comment-content {
        color: rgba(203, 213, 225, 0.92);
        margin: 8px 0 4px;
        font-size: 15px;
        line-height: 1.6;
    }

    .article-detail-page .my-view-comment-tool {
        color: rgba(0, 255, 245, 0.9) !important;
        cursor: pointer;
    }

    .article-detail-page .my-view-comment-tool:hover {
        color: #00fff5 !important;
        text-shadow: 0 0 8px rgba(0, 255, 245, 0.4);
    }

    .article-detail-page .my-reply-list {
        border-left-color: rgba(0, 255, 245, 0.25);
    }

    .article-detail-page .my-reply-item {
        border-bottom-color: rgba(0, 255, 245, 0.1);
    }

    .article-detail-page .my-reply-item div {
        color: rgba(203, 213, 225, 0.9);
    }

    .article-detail-page .my-reply-user {
        color: #00fff5;
    }

    .article-detail-page .my-view-comment-write .el-button--text {
        color: #00fff5;
    }
</style>
